import Axios from 'axios'
import { getCurrentUser } from './auth'

const baseURL = `${process.env.GATSBY_CMS_URL}/wp-json`
const user = getCurrentUser()
const { token } = user
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json; charset=UTF-8',
  },
}
export const getSlots = async date => {
  const url = `${baseURL}/wp/v2/wpo_bookly_timeslots?staffid=1&serviceid=1&date=${date}`

  const response = await Axios.get(url, config)
    .then(result => {
      return result.data
    })
    .catch(err => {
      return err
    })
  return response
}
export const getBookingsFromDay = async date => {
  const url = `${baseURL}/wp/v2/wpo_bookly_appointments?filter[startdate]=${date}&filter[enddate]=${date}`

  const response = await Axios.get(url, config)
    .then(result => {
      return result.data
    })
    .catch(err => {
      return err
    })
  return response.lenght === undefined ? 0 : response.lenght
}

export const createApointment = async data => {
  const url = `${baseURL}/wp/v2/wpo_bookly_appointments`

  const response = await Axios.post(url, data, config)
    .then(result => {
      return result.message
    })
    .catch(err => {
      return err
    })
  return response
}
